import { Button } from "./ui/button";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
  DialogDescription, DialogFooter, DialogClose
} from "./ui/dialog";
import { Calendar as CalendarIcon, Loader2 } from "lucide-react";
import { format } from "date-fns";

export function MarkAnsweredDialog({
  open,
  onOpenChange,
  selectedPrayer,
  answeredForm,
  setAnsweredForm,
  onSubmit,
  formLoading,
  testIdPrefix = ""
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-serif">Mark as Answered</DialogTitle>
          <DialogDescription>
            Record how this prayer was answered
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          {selectedPrayer && (
            <div className="bg-stone/30 rounded-lg p-3 text-sm text-stone-dark">
              "{selectedPrayer.request}"
            </div>
          )}

          <div className="space-y-2">
            <Label htmlFor={`${testIdPrefix}answerResult`}>How was this prayer answered?</Label>
            <Textarea
              id={`${testIdPrefix}answerResult`}
              placeholder="Describe the answer or result..."
              value={answeredForm.result}
              onChange={(e) => setAnsweredForm({ ...answeredForm, result: e.target.value })}
              className="min-h-24"
              data-testid={`${testIdPrefix}answer-result-input`}
            />
          </div>

          <div className="space-y-2">
            <Label>Date Answered</Label>
            <Popover>
              <PopoverTrigger asChild>
                <Button
                  variant="outline"
                  className="w-full justify-start text-left font-normal"
                  data-testid={`${testIdPrefix}answer-date-input`}
                >
                  <CalendarIcon className="mr-2 h-4 w-4" />
                  {answeredForm.date_answered ? format(answeredForm.date_answered, "PPP") : "Select date"}
                </Button>
              </PopoverTrigger>
              <PopoverContent className="w-auto p-0" align="start">
                <Calendar
                  mode="single"
                  selected={answeredForm.date_answered}
                  onSelect={(date) => setAnsweredForm({ ...answeredForm, date_answered: date })}
                  initialFocus
                />
              </PopoverContent>
            </Popover>
          </div>

          <DialogFooter>
            <DialogClose asChild>
              <Button type="button" variant="outline" className="rounded-full">Cancel</Button>
            </DialogClose>
            <Button
              type="submit"
              className="bg-sage hover:bg-sage-dark text-white rounded-full"
              disabled={formLoading}
              data-testid={`${testIdPrefix}submit-answered-btn`}
            >
              {formLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Mark as Answered"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
